module.exports = __webpack_public_path__ + "05_mustache_grey.b8589e6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer3/05_mustache_grey.png
// module id = Xm7V
// module chunks = 0